import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function H1Icon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.537 7.05709C16.8173 7.17318 17 7.44665 17 7.75V15.5H18.25C18.6642 15.5 19 15.8358 19 16.25C19 16.6642 18.6642 17 18.25 17H14.75C14.3358 17 14 16.6642 14 16.25C14 15.8358 14.3358 15.5 14.75 15.5H15.5V9.56066L15.2803 9.78033C14.9874 10.0732 14.5126 10.0732 14.2197 9.78033C13.9268 9.48744 13.9268 9.01256 14.2197 8.71967L15.7197 7.21967C15.9342 7.00517 16.2568 6.941 16.537 7.05709ZM5.75 7C6.16421 7 6.5 7.33579 6.5 7.75V11.5H10.5V7.75C10.5 7.33579 10.8358 7 11.25 7C11.6642 7 12 7.33579 12 7.75V16.25C12 16.6642 11.6642 17 11.25 17C10.8358 17 10.5 16.6642 10.5 16.25V13H6.5V16.25C6.5 16.6642 6.16421 17 5.75 17C5.33579 17 5 16.6642 5 16.25V7.75C5 7.33579 5.33579 7 5.75 7Z"
        fill="currentColor"
      />
    </svg>
  );
};
